module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers",
    class: {
      '-fixed-height-box': _vm.pcDisp
    },
    attrs: {
      "id": "pers-tab7",
      "name": "hres31x-tab7"
    }
  }, [_vm._l((_vm.detail.tableExpWork.rows), function(value, index) {
    return [_c('detail-template', {
      attrs: {
        "index": index,
        "labels": _vm.labels,
        "detail": _vm.detail
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('div', {
              staticClass: "sub-topic-box color-skin",
              attrs: {
                "slot": "head"
              },
              on: {
                "click": function($event) {
                  _vm.toggleDisp()
                }
              },
              slot: "head"
            }, [_c('i', {
              staticClass: "fa fa-laptop icon-sub-topic",
              attrs: {
                "aria-hidden": "true"
              }
            }), _vm._v(" "), _c('div', {
              staticClass: "sub-topic"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC7']['10']) + " ( " + _vm._s(_vm.labels['HRES31XC7']['20']) + "  " + _vm._s(index + 1) + " )")])]), _vm._v(" "), _c('div', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (_vm.topicDisp),
                expression: "topicDisp"
              }],
              staticClass: "data-pers-box",
              attrs: {
                "slot": "body"
              },
              slot: "body"
            }, [_c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC7']['30']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(value.desnoffi))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC7']['40']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(value.deslstjob1))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC7']['50']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(value.deslstpos))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC7']['60']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(_vm.setDateOutput(value.dtestart)))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC7']['70']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(_vm.setDateOutput(value.dteend)))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC7']['80']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(value.desres))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC7']['90']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(value.wrk_location))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC7']['100']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(value.telnum))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC7']['110']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(value.leader))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC7']['120']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(value.salnow))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC7']['130']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(value.remark))])])])])
          
        },
        staticRenderFns: []
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71985a74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres31x/tab7.vue
// module id = 3858
// module chunks = 1